import { AlertTriangle, AlertCircle, Info, X } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { formatRelativeTime } from '@/lib/utils'
import type { AlertRow } from '@/api/types'

interface AlertCardProps {
  alert: AlertRow
  onDismiss?: () => void
}

const severityConfig = {
  critical: {
    icon: AlertTriangle,
    bg: 'bg-destructive/10 border-destructive/20',
    iconColor: 'text-destructive',
  },
  warning: {
    icon: AlertCircle,
    bg: 'bg-warning/10 border-warning/20',
    iconColor: 'text-warning',
  },
  info: {
    icon: Info,
    bg: 'bg-muted border-border',
    iconColor: 'text-muted-foreground',
  },
}

export function AlertCard({ alert, onDismiss }: AlertCardProps) {
  const config = severityConfig[alert.severity]
  const Icon = config.icon

  return (
    <div className={`flex items-start gap-3 rounded-lg border p-3 ${config.bg}`}>
      <Icon className={`mt-0.5 h-5 w-5 shrink-0 ${config.iconColor}`} />
      <div className="flex-1 min-w-0">
        <p className="text-sm font-medium leading-tight">{alert.message}</p>
        <p className="mt-1 text-xs text-muted-foreground">
          {formatRelativeTime(alert.created_at)}
        </p>
      </div>
      {onDismiss && !alert.acknowledged && (
        <Button variant="ghost" size="icon" className="h-6 w-6 shrink-0" onClick={onDismiss}>
          <X className="h-4 w-4" />
        </Button>
      )}
    </div>
  )
}
